/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { Loading3 } from "../components/loading";
import {
  getCurrenciesBaseList,
  getCurrenciesList,
  getCurrenciesRate,
  getOtpMethodByEmail,
  getProfile,
  getWalletList,
  getWeb3OwnerProof,
  getWeb3OwnerProofsByUser,
  postUserLanguage,
} from "../services/app";
import { AlertView } from "../components/Alert";
import { ethers } from "ethers";
import {
  defaultLanguage,
  languageCodes,
  translations,
} from "../languages";
import { useNavigate } from "react-router-dom";

import xsgtContract from "../xsgtContract.json";
import sgtContract from "../sgtContract.json"; //
import sgtStakingContract from "../sgtStakingContract.json";
import sgtStakingContractClaimAbi from "../sgtStakingClaimContract.json";
import Cookies from "js-cookie";
import { useSearchParams } from "react-router-dom";
import {
  findConversionRateBFS,
  getCookie,
  removeCookie,
  setCookie,
  ssoLoginUrl,
  ssoLogoutUrl,
  // formatSearchUrl,
} from "../utils/helper";
import {
  CLAIM_DATA_KEY,
  COUNTRY_CODES,
  CountryCode,
  DOMAIN_COOKIE,
  FORMAT_BALANCE_BY_CURRENCY,
  KEY_COOKIE,
  MapCurrency,
  USD,
  ZENDESK_URLS,
} from "../constants";
import { LoadingSplash2 } from "../components/Loading2";
import { useWindowSize } from "../hook/useWindowSize";
import { baseCurrencyCode, CURRENCY_CODES, decimalScaleByCurrency, decimalSeparatorByCurrency, prefixCcySymbol, suffixCcySymbol, thousandSeparatorByCurrency } from "../utils/Currency";
import NumberFormat from "react-number-format";
import ModalVerifyWallet from "../pages/stake-for-voting/components/ModalVerifyWallet";
import { ModalConfirmProvider } from "../components/ModalConfirm/ModalConfirmContext";
import { VerificationMethodProvider } from "../components/ModalVerificationMethod/verificationMethodContext";

export const SplashScreenView = () => {
  return (
    <div className={"splash-screen"}>
      <img src={`/assets/images/favicon.svg`} alt=""/>
    </div>
  );
};

export const cryptoType = 1;
export const gameType = 2;
export const optionType = 4;
export const SZT_SOURCE = {
  MLM: "MLM",
  SUZU: "SUZU",
};

const Index = React.createContext({});
const localStorage = window.localStorage;

const xsgtContractAbi = xsgtContract.abi;
// const xsgtContractAddress = xsgtContract.address;
const xsgtContractProvider = new ethers.providers.JsonRpcProvider(
  process.env.REACT_APP_INFURA_URL
);
const sgtContractAbi = sgtContract.abi;
// const sgtContractAddress = sgtContract.address;
const sgtContractProvider = new ethers.providers.JsonRpcProvider(
  process.env.REACT_APP_INFURA_URL
);
const sgtStakingContractAbi = sgtStakingContract.abi;
const sgtStakingClaimContractAbi = sgtStakingContractClaimAbi.abi;
// const sgtStakingContractAddress = sgtStakingContract.address;
const sgtStakingContractProvider = new ethers.providers.JsonRpcProvider(
  process.env.REACT_APP_INFURA_URL
);

export const AppProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const isLogin = searchParams.get("tab") === "login";
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(0);
  const [loading, setLoading] = useState(true);
  const [theme, setTheme] = useState("default");
  const [prePosition, setPrePosition] = useState(null);
  const [language, setLanguage] = useState();
  const [subOrderData, setSubOrderData] = useState(null);
  const [claimData, setClaimData] = useState(
    JSON.parse(localStorage.getItem(CLAIM_DATA_KEY) || "{}")
  );
  const [currencies, setCurrencies] = useState([]);
  const [currenciesBase, setCurrenciesBase] = useState([]);
  let [stats, setStats] = useState([]);
  let [currencyRates, setCurrencyRates] = useState([]);
  let [wallets, setWallets] = useState([]);
  let [alert, setAlert] = useState();
  let [splash, setSplash] = useState(true);
  let [currency, setCurrency] = useState("USD");
  let [popup, setPopup] = useState();
  const [web3Provider, setWeb3Provider] = useState(null);
  const [addressConnected, setAddressConnected] = useState("");
  const [masterContract, setMasterContract] = useState(null);
  const [isTabLogin, setIsTabLogin] = useState(isLogin);
  const appRef = useRef();
  const size = useWindowSize();
  const isMobile = size.width < 1024;
  const navigate = useNavigate();
  const isCanConvertAffiliate = [CountryCode.indo].includes(user?.country_code)
  // start handle metamask
  async function disconnectWallet(callback) {
    try {
      Cookies.set("is_disconnect_wallet", "true");
      connectAddress(null);
      if (callback) {
        callback();
      }
    } catch (err) {
      console.error(err);
    }
  }

  const [userWeb3Addresses, setUserWeb3Addresses] = React.useState([]);
  useEffect(() => {
    if (ready === 0 || !user?.token) return;
    const fetchUserWeb3Addresses = async () => {
      try {
        const res = await getWeb3OwnerProofsByUser();
        if (res.status === 200) {
          const addresses = res.data?.data?.map(i => i.walletAddress)?.filter(Boolean) ?? [];
          setUserWeb3Addresses([...new Set(addresses)]); // Remove duplicates
        }
      } catch (error) {
        console.error("Error fetching user web3 addresses:", error);
      }
    };
    fetchUserWeb3Addresses();
  }, [user?.token, ready, addressConnected]);

  const [isShowVerifyModal, setIsShowVerifyModal] = React.useState(false);
  const [web3OwnerProof, setWeb3OwnerProof] = React.useState({});
  const migrateOldStaking = async (address) => {
    try {
      const res = await getWeb3OwnerProof(address);
      if (res.status === 200) {
        const { data } = res;
        if (!data?.isIdentified) {
          setWeb3OwnerProof({
            address: address,
            token: data?.token,
          });
          setIsShowVerifyModal(true);
        } else {
          setAddressConnected(address);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onVerified = (address) => {
    setAddressConnected(address);
    setIsShowVerifyModal(false);
  }

  const connectAddress = async (address) => {
    if (address) {
      migrateOldStaking(address);
    } else {
      setAddressConnected(null);
    }
  }

  async function changeWallet(callback) {
    try {
      await window.ethereum
        .request({
          method: "wallet_requestPermissions",
          params: [{ eth_accounts: {} }],
        })
        .then((response) => {
          Cookies.remove("is_disconnect_wallet");
          setAddressConnected(window.ethereum.selectedAddress);
          if (callback) {
            callback(response);
          }
        });
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    if (!user?.id) return;
    const xsgtContract = new ethers.Contract(
      process.env.REACT_APP_XSGT_ADDRESS,
      xsgtContractAbi,
      xsgtContractProvider
    );
    const sgtContract = new ethers.Contract(
      process.env.REACT_APP_SGT_ADDRESS,
      sgtContractAbi,
      sgtContractProvider
    );
    const sgtStakingContract = new ethers.Contract(
      process.env.REACT_APP_SGT_STAKING_ADDRESS,
      sgtStakingContractAbi,
      sgtStakingContractProvider
    );
    const sgtStakingClaimContract = new ethers.Contract(
      process.env.REACT_APP_SGT_STAKING_CLAIM_ADDRESS,
      sgtStakingClaimContractAbi,
      sgtStakingContractProvider
    );
    setMasterContract({
      xsgtContract,
      sgtContract,
      sgtStakingContract,
      sgtStakingClaimContract
    });
  }, [user?.id]);

  useEffect(() => {
    if (!web3Provider?.provider) {
      connectAddress(null);
      return;
    }
  }, [web3Provider?.provider]);

  useEffect(() => {
    const is_disconnect_wallet = Cookies.get("is_disconnect_wallet");
    if (is_disconnect_wallet === "true" || !user?.id) return;
    if (!window?.ethereum?.selectedAddress) {
      connectAddress(null);
    }
  }, [user?.id]);

  useEffect(() => {
    if (!user?.id) {
      setWeb3Provider(null);
      return;
    }

    async function initProvider() {
      if (window.ethereum) {
        const web3Provider = new ethers.providers.Web3Provider(window.ethereum);
        setWeb3Provider(web3Provider);
      } else {
        console.log("Window.ethereum not found");
      }
    }

    initProvider();
  }, [user?.id]);

  // end handle metamask
  useEffect(() => {
    setIsTabLogin(isLogin);
  }, [isLogin]);

  useEffect(() => {
    setTimeout(() => {
      setSplash(false);
    }, 1000);
  }, []);

  useEffect(() => {
    let timer;
    if (alert) {
      timer = setTimeout(() => setAlert(null), 2000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [alert]);

  useEffect(() => {
    const run = async () => {
      const url = new URL(window?.location?.href);
      const token = url.searchParams.get("token");
      const earnerId = url.searchParams.get("earner_id");

      initializeUserLanguage();

      if (token) {
        const urlCurrent = window.location.href;
        let redirectUrl = urlCurrent.replace(`?token=${token}`, "");
        redirectUrl = redirectUrl.replace(`&token=${token}`, "");
        if(redirectUrl.includes("&") && !redirectUrl.includes("?")) {
          redirectUrl = redirectUrl.replace("&", '?')
        }
        const linkLogin = ssoLoginUrl({
          access_token: token,
          redirect_uri: redirectUrl,
        });
        window.location.href = linkLogin;
        return 0;
      }
      const refreshToken = getCookie(
        KEY_COOKIE.AUTH_TOKEN_COOOKIE
      )?.refresh_token;
      const accessToken = getCookie(
        KEY_COOKIE.AUTH_TOKEN_COOOKIE
      )?.access_token;
      const expires_in = getCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE)?.expires_in;
      let userLocal = {};
      if (expires_in > new Date().getTime()) {
        userLocal = { token: accessToken, refreshToken };
      }
      setUser(userLocal);
      setLoading(false);
      if (earnerId && !token) {
        navigate(`/earner-detail/${earnerId}`);
      }
      return 1;
    };
    run().then((response) => {
      if (response) setReady(1);
    });
  }, []);

  useEffect(() => {
    if (ready === 0) return;
    const run2 = async () => {
      localStorage.setItem("USER", !!user ? JSON.stringify(user) : "");
      window.user = user;
      if (user?.token) {
        loadData();
      }
      if (user?.token && (!user?.id || !user?.email)) {
        const value = await getProfile();
        if (value.status === 200 && value?.data?.data) {
          let data = {
            ...(value?.data?.data || {}),
            ...user,
          };
          data.avatar = (
            data?.Chat_head ||
            (typeof data?.avatar === "string" ? data?.avatar : "") ||
            ""
          ).toString();
          setCurrencyByCountryCode(data);
          if (data?.email) {
            const otpRes = await getOtpMethodByEmail(data?.email);
            if (otpRes.data) {
              const otpMethodData = otpRes.data?.data ?? {};
              data = {
                ...data,
                otpMethod: otpMethodData.otp_method,
                lineUserId: otpMethodData.line_user_id,
                isLineFriendship: otpMethodData.is_line_friendship,
                lineDisplayName: otpMethodData.line_display_name,
              };
            }
          }
          const cookieLanguage = getCookie(KEY_COOKIE.LOCALE);
          const userLanguage = data?.language;
          if (cookieLanguage && userLanguage && cookieLanguage !== userLanguage) {
            onSetLanguage(cookieLanguage);
          }
          setUser(data);
        }
      }
      setReady(2);
    };
    run2();
  }, [user?.token, user?.reload, ready]);

  const initializeUserLanguage = () => {
    const url = new URL(window?.location?.href);
    let fixedLanguage = url.searchParams.get("language");
    if (fixedLanguage === "zh") {
      fixedLanguage = "cn";
    }
    if (fixedLanguage === "kr") {
      fixedLanguage = "ko";
    }
    if (fixedLanguage === "jp") {
      fixedLanguage = "ja";
    }
    if (fixedLanguage === "english") {
      fixedLanguage = "en";
    }

    let valueLanguageStored = getCookie(KEY_COOKIE.LOCALE);
    if (valueLanguageStored === "zh") {
      valueLanguageStored = "cn";
    }
    if (valueLanguageStored === "english") {
      valueLanguageStored = "en";
    }
    if (valueLanguageStored === "kr") {
      valueLanguageStored = "ko";
    }
    if (valueLanguageStored === "jp") {
      valueLanguageStored = "ja";
    }
    if (fixedLanguage && languageCodes.includes(fixedLanguage)) {
      onSetLanguage(fixedLanguage);
    } else {
      if (
        !valueLanguageStored ||
        !languageCodes.includes(valueLanguageStored)
      ) {
        const languageCode = (
          window?.navigator?.language ||
          window?.navigator?.userLanguage ||
          defaultLanguage
        ).split("-")[0];
        if (languageCodes.includes(languageCode)) {
          onSetLanguage(languageCode);
        } else {
          onSetLanguage(defaultLanguage);
        }
      } else {
        onSetLanguage(valueLanguageStored);
      }
    }
  };

  const setCurrencyByCountryCode = (data) => {
    switch (data?.country_code) {
      case COUNTRY_CODES.JAPAN:
        setCurrency(CURRENCY_CODES.JPY);
        break;
      case COUNTRY_CODES.UNITED_STATES:
        setCurrency(CURRENCY_CODES.USD);
        break;
      case COUNTRY_CODES.MALAYSIA:
        setCurrency(CURRENCY_CODES.MYR);
        break;
      case COUNTRY_CODES.VIETNAM:
        setCurrency(CURRENCY_CODES.VND);
        break;
      case COUNTRY_CODES.PHILIPPINES:
        setCurrency(CURRENCY_CODES.PHP);
        break;
      case COUNTRY_CODES.THAILAND:
        setCurrency(CURRENCY_CODES.THB);
        break;
      case COUNTRY_CODES.INDONESIA:
        setCurrency(CURRENCY_CODES.IDR);
        break;
      case COUNTRY_CODES.COLOMBIA:
      case COUNTRY_CODES.MEXICO:
      case COUNTRY_CODES.EL_SALVADOR:
      case COUNTRY_CODES.URUGUAY:
      case COUNTRY_CODES.PARAGUAY:
      case COUNTRY_CODES.PANAMA:
      case COUNTRY_CODES.VENEZUELA:
      case COUNTRY_CODES.DOMINICAN_REPUBLIC:
      case COUNTRY_CODES.CHILE:
      case COUNTRY_CODES.ARGENTINA:
      case COUNTRY_CODES.ECUADOR:
      case COUNTRY_CODES.BRAZIL:
      case COUNTRY_CODES.SPAIN:
        setCurrency(CURRENCY_CODES.BRL);
        break;
      default:
        setCurrency(CURRENCY_CODES.USD);
        break;
    }
  }

  useEffect(() => {
    window.language = language;
    if (language) {
      document.querySelector("title").innerText = T("title");
      document
        .querySelector('meta[name="description"]')
        ?.setAttribute("content", T("description"));
      document
        .querySelector('meta[name="og:description"]')
        ?.setAttribute("content", T("description"));
      document
        .querySelector('meta[name="og:title"]')
        ?.setAttribute("content", T("title"));
    }
  }, [language]);

  // useEffect(() => {
  //   if (currency) {
  //     localStorage.setItem("CURRENCY", currency);
  //   }
  // }, [currency]);

  useEffect(() => {
    if (!appRef.current) {
      appRef.current = { timer: null };
    }
    if (user?.id && currencies?.length) {
      if (appRef?.current?.timer) {
        clearInterval(appRef?.current?.timer);
      }
      appRef.current.timer = setInterval(() => {
        getCurrenciesRate().then((result) => {
          if (result?.status === 200) {
            setCurrencyRates(result?.data?.data || []);
          }
        });
      }, 5000);
    }
    return () => {
      if (appRef?.current?.timer) {
        clearInterval(appRef?.current?.timer);
      }
    };
  }, [user?.id, currencies]);

  const reloadProfile = async () => {
    const currentTokenUser = window.user?.token;
    const value = await getProfile();
    if (value.status === 200 && value?.data?.data) {
      let data = {
        ...user,
        ...(value?.data?.data || {}),
        token: currentTokenUser,
        reload: Date.now(),
      };
      data.avatar = (
        data?.Chat_head ||
        (typeof data?.avatar === "string" ? data?.avatar : "") ||
        ""
      ).toString();
      if (data?.email) {
        const otpRes = await getOtpMethodByEmail(data?.email);
        if (otpRes.data) {
          const otpMethodData = otpRes.data?.data ?? {};
          data = {
            ...data,
            otpMethod: otpMethodData.otp_method,
            lineUserId: otpMethodData.line_user_id,
            isLineFriendship: otpMethodData.is_line_friendship,
            lineDisplayName: otpMethodData.line_display_name,
          };
        }
      }
      setUser(data);
    }
  };

  const logout = () => {
    disconnectWallet();
    window.localStorage.removeItem("USER");
    window.user = null;
    const token = user?.token;
    const linkLogout = ssoLogoutUrl(token);
    removeCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE);
    removeCookie(KEY_COOKIE.STATUS_VERIFY_PHONE);
    window.location.href = linkLogout;
    // setUser(null);
  };

  // Language
  const T = (key) => {
    const value = translations[language] || {};
    return value[key] || key;
  };

  const formatLocalCurrencyLegacy = (value) => {
    const prefix = MapCurrency[currency] ?? USD;
    const format = FORMAT_BALANCE_BY_CURRENCY[currency];
    try {
      value = value.toString().split(" ").join("");
      if (format !== undefined) {
        return `${prefix} ${parseFloat(
          parseFloat(value.toString().split(",").join(""))?.toFixed(format)
        )?.toLocaleString("en-US") || "0"
          }`;
      }
      return `${prefix} ${value}`;
    } catch (e) {
      return "-";
    }
  };

  const formatLocalCurrency = (value) => {
    try {
      const prefix = prefixCcySymbol(true, getCurrency());
      const suffix = suffixCcySymbol(true, getCurrency());
      const thousandSeparator = thousandSeparatorByCurrency(getCurrency());
      const decimalSeparator = decimalSeparatorByCurrency(getCurrency());
      const decimalScale = decimalScaleByCurrency(
        baseCurrencyCode(true, getCurrency())
      );
      let [intPart, fracPart = ''] = Number(value)
      .toFixed(decimalScale)
      .split('.');

      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

      let formattedNumber = decimalScale > 0 ? intPart + decimalSeparator + fracPart : intPart;

      return `${prefix}${formattedNumber}${suffix}`;
    } catch (e) {
      return "-";
    }
  };

  const formatCurrency = (value, length = 8, currency = getCurrency()) => {
    try {
      return (
        <NumberFormat
          className=""
          value={value}
          displayType={"text"}
          thousandSeparator={thousandSeparatorByCurrency(currency)}
          decimalSeparator={decimalSeparatorByCurrency(currency)}
          prefix={""}
          suffix={""}
          decimalScale={length ?? decimalScaleByCurrency(
            baseCurrencyCode(true, currency)
          )}
        />
      );
    } catch (e) {
      return value;
    }
  };

  const getCurrency = useCallback(() => {
    return currency;
  }, [currency]);

  const loadData = async (components = ["wallets", "currencies", "rates"]) => {
    if (user) {
      if (!components?.length || components.includes("wallets")) {
        getWalletList().then((result) => {
          if (result.status === 200) {
            setWallets(result?.data?.data?.wallets?.rows || []);
            setStats(result?.data?.data?.stats || []);
          }
        });
      }
      if (!components?.length || components.includes("currencies")) {
        getCurrenciesList([1,2,3,4]).then((result) => {
          if (result.status === 200) {
            setCurrencies(result?.data?.data || []);
          }
        });
        getCurrenciesBaseList().then((result) => {
          if (result.status === 200) {
            setCurrenciesBase(result?.data?.data || []);
          }
        });
      }
      if (!components?.length || components.includes("rates")) {
        getCurrenciesRate().then((result) => {
          if (result.status === 200) {
            setCurrencyRates(result?.data?.data || []);
          }
        });
      }
    }
  };

  const convertToBTC = useCallback(
    (value, fromCurrency, currency) => {
      if (fromCurrency === "BTC") {
        return value;
      }
      const rate = findConversionRateBFS(currencyRates, fromCurrency, "BTC");
      return parseFloat(value) * rate;
    },
    [currencyRates]
  );

  const convertToLocalCurrency = useCallback(
    (value, fromCurrency, currency) => {
      const format = FORMAT_BALANCE_BY_CURRENCY[currency];
      const currencyToLocal = findConversionRateBFS(
        currencyRates,
        fromCurrency,
        currency
      ); // 1currency=?jpy
      if (format !== undefined) {
        return +(parseFloat(value) * currencyToLocal).toFixed(format);
      }
      return parseFloat(value) * currencyToLocal;
    },
    [currencyRates]
  );

  const convertToCurrency = useCallback(
    (value, fromCurrency, toCurrency) => {
      const format = FORMAT_BALANCE_BY_CURRENCY[toCurrency];
      const rate = findConversionRateBFS(
        currencyRates,
        fromCurrency,
        toCurrency
      ); // 1currency=?jpy
      if (format !== undefined) {
        return +(parseFloat(value) * rate).toFixed(format);
      }
      return parseFloat(value) * rate;
    },
    [currencyRates]
  );

  const contextLoaded = wallets?.length && stats?.length && currencies?.length;

  const cryptoCodes = (currencies || [])
    .filter((item) => item.type === cryptoType)
    .map((item) => item.code);

  const onSetLanguage = (id) => {
    let originId = id;
    let originIdCookie = id;
    if (id) {
      if (id === "zh") {
        originId = "cn";
        originIdCookie = "cn";
      }
      if (id === "english") {
        originId = "en";
      }
      if (id === "kr") {
        originId = "ko";
      }
      if (id === "jp") {
        originId = "ja";
      }
      if (id === "ja") {
        originIdCookie = "jp";
      }
      if (id === "en") {
        originIdCookie = "english";
      }
      setLanguage(originId);
      setUser((user) => ({...user, language: originIdCookie }));
      setCookie(KEY_COOKIE.LOCALE, originIdCookie, {
        domain: DOMAIN_COOKIE,
        maxAge: Date.now() + 36135 * 86400000,
      });
    }
    if (id && user?.id) {
      postUserLanguage(id).then();
    }
  };

  const isUserSocial = !user?.password;

  const onCheckEmail = () => {
    return new Promise((resolve) => {
      if (!user?.email) {
        setPopup("verifyEmail");
      }
      resolve(user?.email);
    });
  };

  const onCheck2FA = async () => {
    if (user) {
      setLoading(true);
      const value = await getProfile();
      setLoading(false);
      if (value.status === 200 && value?.data?.data) {
        const data = { ...user, ...(value?.data?.data || {}) };
        // if change 2fa
        if (data?.is_twofa !== user?.is_twofa) {
          setUser({ ...user, is_twofa: data?.is_twofa });
          setAlert({
            type: "error",
            text: data?.is_twofa
              ? T("Your 2FA authentication is already enabled.")
              : T("Your 2FA authentication is already disabled."),
          });
          return true;
        }
      }
    }
    setPopup("2fa");
    return false;
  };

  const helpRequestNewLink = useMemo(() => {
    switch (language) {
      case "ja":
        return `${ZENDESK_URLS.JA.HELP}/requests/new`;
      case "ko":
        return `${ZENDESK_URLS.KO.HELP}/requests/new`;
      case "cn":
        return `${ZENDESK_URLS.CN.HELP}/requests/new`;
      case "tc":
        return `${ZENDESK_URLS.TC.HELP}/requests/new`;
      case "vi":
        return `${ZENDESK_URLS.VI.HELP}/requests/new`;
      case "id":
        return `${ZENDESK_URLS.ID.HELP}/requests/new`;
      case "pt":
        return `${ZENDESK_URLS.PT.HELP}/requests/new`;
      case "es":
        return `${ZENDESK_URLS.ES.HELP}/requests/new`;
      default:
        return `${ZENDESK_URLS.EN.HELP}/requests/new`;
    }
  }, [language]);

  if (typeof window !== "undefined" && ready) {
    return (
      <Index.Provider
        value={{
          user,
          currencies,
          stats,
          currencyRates,
          wallets,
          contextLoaded,
          alert,
          cryptoCodes,
          currency,
          popup,
          isUserSocial,
          web3Provider,
          addressConnected,
          masterContract,
          isTabLogin,
          claimData,
          loading,
          subOrderData,
          theme,
          currenciesBase,
          prePosition,
          language: language || "en",
          isMobile,
          isCanConvertAffiliate,
          userWeb3Addresses,
          setUser,
          logout,
          setLoading,
          T,
          setTheme,
          setSubOrderData,
          setLanguage,
          setClaimData,
          formatLocalCurrency,
          formatLocalCurrencyLegacy,
          getCurrency,
          convertToBTC,
          convertToCurrency,
          setPrePosition,
          convertToLocalCurrency,
          loadData,
          loadContextData: loadData,
          setAlert,
          setCurrency,
          onSetLanguage,
          setPopup,
          onCheckEmail,
          onCheck2FA,
          disconnectWallet,
          changeWallet,
          reloadProfile,
          formatCurrency,
          connectAddress
        }}
      >
        <ModalConfirmProvider translateFn={T}>
          <VerificationMethodProvider translateFn={T} user={user} reloadProfile={reloadProfile} helpLink={helpRequestNewLink} setGlobalLoading={setLoading}>
            {ready === 2 ? children : <LoadingSplash2 />}
            {loading ? <Loading3 /> : null}
            {alert ? (
              <AlertView
                onClose={() => setAlert(null)}
                text={alert?.text || T("Error while making the request!")}
                type={alert?.type || "error"}
              />
            ) : null}
            {splash ? <LoadingSplash2 /> : null}
            {isShowVerifyModal && (
              <ModalVerifyWallet web3OwnerProof={web3OwnerProof} onClose={() => setIsShowVerifyModal(false)} onVerified={onVerified}/>
            )}
          </VerificationMethodProvider>
        </ModalConfirmProvider>
      </Index.Provider>
    );
  }
  return <LoadingSplash2 />;
};

export const useApp = () => React.useContext(Index);

